<template>
  <div>
    <p class="mb-1">
      1. KOHDE
    </p>
    <p v-if="isShare" class="text-caption">
      1.1 Yhtiön nimi: <span class="primary--text ml-1">{{ property.yhtionimi }}</span><br>
      1.2 Osakkeiden / osuuksien numerot:
      <span v-if="property.osakeloppu > 0" class="primary--text ml-1">
        {{ property.osakealku }} - {{ property.osakeloppu }}
      </span>
      <template v-if="property.add_share !== ''">
        ja <span class="primary--text">{{ property.add_share }} - {{ property.add_share2 }}</span>
      </template><br>
      1.3 Huoneiston osoite ja numero:
      <span class="primary--text ml-1">
        {{ property.kohdenimi }} {{ property.huoneistonro }},
        {{ property.postinumero }} {{ property.kaupunki }}
      </span>
    </p>
    <p v-else class="text-caption">
      1.1 Kiinteistötunnus<span v-if="propertyType ===2">/laitostunnus</span>:
      <span class="primary--text ml-1">{{ property.omkkiinteistotunnus }}</span><br>
      1.2 <span v-if="propertyType === 0">Kiinteistörekisterin mukainen pinta-ala</span>
      <span v-else>Vuokra-alueen pinta-ala noin</span>:
      <span class="primary--text ml-1">
        {{ size.replace('.', ',') }} m²
      </span><br>
      1.3 Osoite:
      <span class="primary--text ml-1">
        {{ property.kohdenimi }} {{ property.huoneistonro }},
        {{ property.postinumero }} {{ property.kaupunki }}
      </span>
    </p>

    <p class="mb-1">
      2. TARJOUKSEN TEKIJÄT
    </p>
    <p
      v-for="(offerer, index) in form.offerers"
      :key="index"
      class="text-caption"
    >
      <template v-if="!offerer.isCompany">
        Nimi: <span class="primary--text ml-1">{{ offerer.name }}</span><br>
        Sähköposti: <span class="primary--text ml-1">{{ offerer.email }}</span><br>
      </template>
      <template v-else>
        Yritys: <span class="primary--text ml-1">{{ offerer.companyName }}</span><br>
        Sähköposti: <span class="primary--text ml-1">{{ offerer.email }}</span><br>
        Y-tunnus:
        <span
          :class="offerer.companyNumber ? 'primary--text' : 'grey--text text--lighten-1'"
          class="ml-1"
        >
          {{ offerer.companyNumber || 'Täydennetään allekirjoituksen yhteydessä' }}
        </span><br>
        Edustaja: <span class="primary--text ml-1">{{ offerer.name }}</span><br>
      </template>
      <template v-if="agent">
        Henkilötunnus:
        <span
          :class="offerer.ssn ? 'primary--text' : 'grey--text text--lighten-1'"
          class="ml-1"
        >
          {{ offerer.ssn || 'Täydennetään allekirjoituksen yhteydessä' }}
          (Tieto ei välity osapuolille)
        </span><br>
      </template>
      Kansalaisuus:
      <span
        :class="offerer.nationality ? 'primary--text' : 'grey--text text--lighten-1'"
        class="ml-1"
      >
        {{ offerer.nationality || 'Täydennetään allekirjoituksen yhteydessä' }}
      </span><br>
      Osoite:
      <span
        :class="offerer.address ? 'primary--text' : 'grey--text text--lighten-1'"
        class="ml-1"
      >
        {{ offerer.address || 'Täydennetään allekirjoituksen yhteydessä' }}{{ offerer.zip ?
          `, ${offerer.zip}` : '' }}
        {{ offerer.city }}
      </span><br>
      Puhelin:
      <span
        :class="offerer.phone ? 'primary--text' : 'grey--text text--lighten-1'"
        class="ml-1"
      >
        {{ offerer.phone || 'Täydennetään allekirjoituksen yhteydessä' }}
      </span><br>

      <template v-if="!oldVersion">
        Poliittisesti vaikutusvaltainen henkilö, tällaisen henkilön perheenjäsen tai
        läheinen yhtiökumppani?:
        <span
          :class="offerer.pep ? 'primary--text' : 'grey--text text--lighten-1'"
          class="ml-1"
        >
          {{ offerer.pep ? 'Kyllä' : 'Ei' }}
        </span><br>
        <span v-if="offerer.pep">
          PEP-selite:
          <span
            class="ml-1 primary--text"
          >
            {{ offerer.pepDescription }}
          </span><br>
        </span>
      </template>
    </p>

    <p class="mb-1">
      3. KAUPPASUMMA<span v-if="isShare">, VELKAOSUUS</span> JA MAKSUTAPA
    </p>
    <div v-if="isShare" class="text-caption">
      3.1 Velaton kauppahinta:
      <span class="primary--text ml-1">
        {{ form.offer.toString().replace('.', ',') }} euroa
      </span><br>
      3.2 Myyntihinta:
      <span class="primary--text ml-1">
        {{ sellingPrice.toString().replace('.', ',') }} euroa
      </span><br>
      3.3 Maksuaikataulu ja maksutapa:
      <span class="primary--text ml-1">
        {{ form.paymentMethod }}
        <span v-if="form.paymentMethod === 'Osamaksu'">
          Kaupanteon yhteydessä maksetaan {{ form.paymentDetail }} €
          Loppuosa maksetaan {{ paymentDateFormatted }}
        </span>
        <span v-if="form.paymentMethod === 'Muu (anna selite)'">
          {{ form.paymentOther }}
        </span>
      </span>
      <br>
      3.4 Velkaosuus:
      <span class="primary--text ml-1">
        {{ form.debt.replace('.', ',') }} euroa.
        {{ `Isännöitsijäntodistuksen päivämäärä: ${debtDateFormatted}.` }}
        {{ debtDateText }}
      </span><br>
      Velkaosuuden maksaminen:
      <span v-if="form.debtPortionPayer === 2" class="primary--text ml-1">
        Ostaja ottaa huoneistokohtaisen velkaosuuden vastattavakseen.
      </span>
      <span v-else-if="form.debtPortionPayer === 1" class="primary--text ml-1">
        Velkaosuus maksetaan pois kaupantekotilaisuudessa.
      </span>
      <p class="text-caption grey--text">
        {{ debtPartText }}
      </p>
    </div>
    <div v-else class="text-caption">
      3.1 Kauppahinta:
      <span class="primary--text ml-1">
        {{ form.offer.toString().replace('.', ',') }} euroa
      </span><br>
      3.2 Maksuaikataulu ja maksutapa:
      <span class="primary--text ml-1">
        {{ form.paymentMethod }}
        <span v-if="form.paymentMethod === 'Osamaksu'">
          Kaupanteon yhteydessä maksetaan {{ form.paymentDetail }} €
          Loppuosa maksetaan {{ paymentDateFormatted }}
        </span>
        <span v-if="form.paymentMethod === 'Muu (anna selite)'">
          {{ form.paymentOther }}
        </span>
      </span>
    </div>

    <p class="mb-1 mt-4">
      4. OIKEUKSIEN<span v-if="!isShare"> JA VELVOLLISUUKSIEN</span> SIIRTYMINEN
    </p>
    <p class="text-caption">
      4.1 Omistusoikeuden siirtyminen:
      <span class="primary--text ml-1">
        {{ form.ownershipTransfer === 0 ?
          'Siirtyy kaupanteossa' : form.ownershipTransfer === 1 ?
            form.ownershipTransferDetail : 'Ei valittu' }}
      </span><br>
      4.2 Hallintaoikeuden siirtyminen:
      <span class="primary--text ml-1">
        {{ form.possessionTransfer === 0 ?
          'Siirtyy kaupanteossa' : form.possessionTransfer === 1 ?
            form.possessionTransferDetail : 'Ei valittu' }}
      </span><br>
      4.3 Viivästyskorvaus:
      <span v-if="form.paymentDelay === ''" class="primary--text ml-1">
        Ei valittu
      </span>
      <span v-else class="primary--text ml-1">
        {{ form.paymentDelay }} euroa
      </span><br>
      4.4 Vastuu maksuista:
      <span class="primary--text ml-1">
        {{ form.expense === 0 ?
          'Hallintaoikeuden siirtymisestä lähtien' : form.expense === 1 ?
            form.expenseDetail : 'Ei valittu' }}
      </span>
      <span v-if="propertyType === 0">
        <br>
        4.5 Vaaranvastuun siirtyminen ostajalle:
        <span class="primary--text ml-1">
          {{ form.risk === 0 ?
            'Omistusoikeuden siirtymisestä lähtien' : form.risk === 1 ?
              form.riskDetail : 'Ei valittu' }}
        </span>
      </span>
    </p>

    <p class="mb-1">
      5. TARJOUKSEN EHDOT
    </p>
    <div class="text-caption mb-4">
      5.1 Vastuunrajoituslausekkeet:
      <ul>
        <li v-if="form.conditions.loan" class="primary--text ml-1">
          Lainan saanti
        </li>
        <li v-if="form.conditions.sell" class="primary--text ml-1">
          Oman asunnon myynti
        </li>
        <li v-if="form.conditions.permit" class="primary--text ml-1">
          Viranomaisen lupa
        </li>
        <li v-if="form.conditions.condition" class="primary--text ml-1">
          Kosteusmittaus / kuntotarkastus
        </li>
        <li v-if="form.conditions.conditiononly" class="primary--text ml-1">
          Kuntotarkastus
        </li>
        <li v-if="form.conditions.humidity" class="primary--text ml-1">
          Kosteusmittaus
        </li>
      </ul>
      <p v-if="form.conditions.condition" class="text-caption mt-2 grey--text">
        Mikäli kosteusmittauksessa / kuntotarkastuksessa ilmenee asunnon ikä, kunto ja vastaavat
        seikat huomioon ottaen sellaisia merkittäviä vikoja tai puutteita, joista ostaja ei ole
        aiemmin ollut tietoinen, on ostajalla oikeus vetäytyä kaupasta. Kosteusmittauksen /
        kuntotarkastuksen kustannuksista vastaavat myyjä ja ostaja puoliksi.
      </p>
      <ul v-if="form.conditions.marketing">
        <li class="primary--text ml-1">
          Kohde pysyy markkinoinnissa ja myyjällä on oikeus hyväksyä kolmannen
          osapuolen tarjous ilman sanktioita
        </li>
      </ul>
      5.2 Varainsiirtovero:
      <ul v-if="isShare">
        <li
          v-for="(offerer, index) in form.offerers"
          :key="index"
          class="primary--text"
        >
          {{ offerer.isCompany ? offerer.companyName : offerer.name }}
          {{ offerer.assetTransfer && !offerer.isCompany ? 'ei varainsiirtoverovelvollinen' :
            'maksaa varainsiirtoveron kaupantekotilaisuudessa' }}
        </li>
      </ul>
      <ul v-else>
        <li
          v-for="(offerer, index) in form.offerers"
          :key="index"
          class="primary--text"
        >
          {{ offerer.isCompany ? offerer.companyName : offerer.name }}
          {{ offerer.assetTransfer && !offerer.isCompany ? 'ei varainsiirtoverovelvollinen' :
            'maksaa varainsiirtoveron' }}
        </li>
      </ul>
      5.3 Muut ehdot:
      <ul>
        <li class="primary--text ml-1">
          {{ form.otherConditions !== '' ? form.otherConditions : 'Ei muita ehtoja' }}
        </li>
      </ul>
      <template v-if="!oldVersion">
        5.4 Liitteet:
        <ul v-if="form.selectedAttachments !== ''">
          <li class="primary--text ml-1">
            {{ form.selectedAttachments }}
          </li>
        </ul>
      </template>
    </div>
    <p class="mb-1">
      6. VAKIOKORVAUS (SOPIMUSSAKKO) TAI KÄSIRAHA
    </p>
    <p class="text-caption">
      {{ form.deposit === form.depositValues[0] ? '6.1 Vakiokorvaus' : '6.2 Käsiraha' }}:
      <span class="primary--text ml-1">
        {{ form.depositInEuros > 0 ? `${form.depositInEuros.replace('.', ',')} euroa` :
          'Ei määritetty' }}
      </span>
    </p>
    <p v-if="form.deposit === form.depositValues[0]" class="text-caption grey--text">
      {{ depositTexts.deposit1 }}
    </p>
    <p v-else class="text-caption grey--text">
      {{ depositTexts.deposit2 }}
    </p>
    <p v-if="propertyType === 0 && !createdAfterLawChange" class="text-caption grey--text">
      {{ depositTexts.deposit3 }}
    </p>
    <p class="mb-1">
      7. TARJOUKSEN VOIMASSAOLO
    </p>
    <p class="text-caption">
      7.1 Päivämäärään asti:
      <span class="primary--text ml-1">
        {{ formatDate(form.offerValidUntilDate) }}
      </span><br>
      7.2 Kellonaikaan asti:
      <span class="primary--text ml-1">
        {{ form.offerValidUntilTime }}
      </span><br>
      7.3 Kauppakirjat allekirjoitettava viimeistään:
      <span class="primary--text ml-1">
        {{ formatDate(form.signingDate) }}
      </span>
    </p>
    <p class="mb-1">
      8. VÄLITYSLIIKKEEN TIEDOT JA KUITTAUS
    </p>
    <p class="text-caption">
      8.1 Välitysliikkeen toiminimi:
      <span class="primary--text ml-1">
        {{ property.companyName }}
      </span><br>
      8.2 Osoite:
      <span class="primary--text ml-1">
        {{ property.companyAddress }}
      </span><br>
      8.3 Y-tunnus:
      <span class="primary--text ml-1">
        {{ property.companyVat }}
      </span><br>
      8.4 Paikka ja aika:
      <span class="primary--text ml-1">
        {{ property.companyCity }}, {{ formatDate(date ? date : new Date(), true) }}
      </span><br>
      8.5 Välitysliikeen kuittaus:
      <span class="primary--text ml-1">
        Sähköinen - {{ signingAgent }}
      </span>
    </p>
    <p class="mb-1">
      9. TARJOUKSENTEKIJÄN ALLEKIRJOITUKSET
    </p>
    <p v-if="!signatures.length" class="text-caption primary--text">
      Ei allekirjoituksia
    </p>
    <p class="text-caption">
      9.1  Allekirjoitettu: {{ signDate ? signDate : '(Allekirjoituksia puuttuu)' }}<br>
      <span v-for="(signer, index) in signatures" :key="index">
        9.{{ index + 2 }} {{ signer.name }}:
        <span class="primary--text ml-1">
          Allekirjoitettu sähköisesti {{ signer.signed_at && formatDateTime(signer.signed_at) }}
        </span><br>
      </span>
    </p>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'PreviewOffer',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    property: {
      type: Object,
      default: () => {},
    },
    date: {
      type: String,
      default: null,
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    signDate: {
      type: String,
      default: () => '',
    },
    signingAgent: {
      type: String,
      default: () => '',
    },
    depositTexts: {
      type: Object,
      default: () => {},
    },
    isShare: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    debtPartText: 'Mikäli mahdollisen velkaosuuden määrää ei makseta pois kaupantekotilaisuudessa, ottaa ostaja huoneistokohtaisen velkaosuuden vastattavakseen. Mikäli velkaosuuden määrä on muuttunut edellä mainitusta, muuttuu maksettavan kauppasumman määrä niin, että hyväksytty velaton kauppahinta pysyy samana. Mahdollisen velkaosuuden määrä pyritään tarkistamaan kaupantekopäivälle. Huoneistokohtainen lainaosuuden määrä on saattanut muuttua pienemmäksi tai suuremmaksi isännöitsijäntodistuksessa mainitusta maksettujen tai mahdollisesti maksamattomien rahoitusvastikkeiden johdosta tai se on voitu maksaa kokonaisuudessaan pois. Viivästyskorko on korkolain mukainen.',
  }),
  computed: {
    ...mapGetters({
      agent: 'agent',
    }),
    debtDateText() {
      if (this.property.velkaosuuspvm) {
        return `Velkaosuuden päivämäärä: ${moment(this.property.velkaosuuspvm, 'YYYY-MM-DD').format('DD.MM.YYYY')}`;
      }
      return '';
    },
    createdAfterLawChange() {
      return moment(this.date, 'YYYY-MM-DD H:m:s') > moment('2024-11-01 00:00:00', 'YYYY-MM-DD H:m:s');
    },
    paymentDateFormatted() {
      return moment(this.form.paymentDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    sellingPrice() {
      return (parseFloat(this.form.offer) - parseFloat(this.form.debt.replace(',', '.'))).toFixed(2);
    },
    debtDateFormatted() {
      if (this.form.debtDate === '') {
        return '';
      }
      return moment(this.form.debtDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    propertyType() {
      if (+this.property.osakevaikiinteisto === 0 && +this.property.tontinomistus > 0) {
        return 2; // vuokraoikeus
      }
      if (+this.property.osakevaikiinteisto === 1) return 1; // osake
      return 0; // kiinteistö
    },
    size() {
      const plots = [4, 13, 14, 15, 18];
      if (plots.includes(+this.property.kohdetyyppi)) {
        return this.property.pintaala;
      }
      return this.property.omktontinpinta;
    },
    oldVersion() {
      return moment(this.date, 'YYYY-MM-DD H:m:s') < moment('2020-11-10 00:00:00', 'YYYY-MM-DD H:m:s');
    },
  },
  methods: {
    formatDate(date, time = false) {
      return time ? moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm') : moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    formatDateTime(datetime) {
      return moment(datetime).format('DD.MM.YYYY H:mm');
    },
  },
};
</script>
<style lang="scss">
.value-color {
  color: #0055cc;
}
</style>
